import { Tenant } from './common';

export type PlacePrediction = google.maps.places.AutocompletePrediction;

export enum AddressComponentType {
  StreetNumber = 'street_number',
  Route = 'route',
  Locality = 'locality',
  Sublocality = 'sublocality',
  SublocalityLevel1 = 'sublocality_level_1',
  SublocalityLevel2 = 'sublocality_level_2',
  AdministrativeAreaLevel1 = 'administrative_area_level_1',
  AdministrativeAreaLevel2 = 'administrative_area_level_2',
  Premise = 'premise',
  Subpremise = 'subpremise',
  Room = 'room',
  Country = 'country',
  PostalCode = 'postal_code',
}

export type GooglePlaceApiResponse = {
  addressComponents: {
    languageCode: string;
    longText: string;
    shortText?: string;
    types?: string[];
  }[];
  displayName:
    | string
    | {
        text: string;
        languageCode?: string;
      };
  formattedAddress: string;
  id: string;
  name: string;
};

export type Branch = {
  id: string;
  branchName: string;
  branchNo: string;
  address: string;
  telephone: string;
};

export type Territory = {
  id: string;
  country: string;
  countryCode: string;
  tenant: Tenant;
  branches: Branch[];
};

export enum CountryISO {
  US = 'USA',
  Cayman = 'CYM',
  Barbados = 'BRB',
  UK = 'GBR',
  China = 'CHN',
  France = 'FRA',
  Grenada = 'GRD',
  Guyana = 'GUY',
  India = 'IND',
  StVincent = 'VCT',
  Trinidad = 'TTO',
  Suriname = 'SUR',
  Australia = 'AUS',
  Bermuda = 'BMU',
  BVI = 'VGB',
  Japan = 'JPN',
}

export type City = {
  name: string;
  value: string;
};
